module.exports = __webpack_public_path__ + "static/media/received.297b6525.png";